import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { ITeamMembers } from "../types";
import { END_POINT } from "config/environment";

export const QUERY_KEY_FOR_TEAM_MEMBERS = "team-members";

const getData = async (props: { token: string }): Promise<ITeamMembers[]> => {
  const url = `${END_POINT.BASE_URL}/v1/team-members`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const res = await axios.get(url, config);
  
  const data: ITeamMembers[] = res.data.map((item: ITeamMembers) => ({
    ...item,
  }));

  return data;
};

export const useGetMembers = () => {
  const { token } = useGetUserInfo();
  const queryData = useQuery(
    [QUERY_KEY_FOR_TEAM_MEMBERS],
    () => getData({ token }),
    {
      onError: (err: any) => {},
      onSuccess: (data) => {},
    }
  );

  return queryData;
};
